<template>
  <v-row class="LKMunMehFormRow">
    <v-col cols="8">
      <div
        :class="{ 'LKMunMehFormRow__title': true, 'bold': bold }"
        v-text="`${index}. ${item.name}`"
      />
    </v-col>
    <v-col cols="2" class="text-right">
      <v-icon
        :color="color"
        size="24px"
        v-text="icon"
      />
    </v-col>
    <v-col cols="2" class="text-right">
      <div
        class="LKMunMehFormRow__title bold"
        v-text="item.max_score"
      />
    </v-col>
  </v-row>
</template>

<script>
import { toNumber } from 'lodash'
import variables from '@/assets/scss/exports.scss'
import { MunMehFormRowStatuses } from '@/typings/api/MunMeh'

export default {
  name: 'LKMunMehFormRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
    idx: {
      type: [String, Number],
      required: true,
    },
    bold: Boolean,
  },
  data: () => ({
    statuses: MunMehFormRowStatuses,
    statusesOptions: {
      [MunMehFormRowStatuses.filled]: {
        icon: 'mdi-checkbox-marked-circle-outline',
        color: variables['webflow-color-green'],
      },
      [MunMehFormRowStatuses.partially_filled]: {
        icon: 'mdi-reload',
        color: variables['webflow-color-orange-2'],
      },
      [MunMehFormRowStatuses.empty]: {
        icon: 'mdi-checkbox-marked-circle-outline',
        color: variables['color-gray'],
      },
    },
  }),
  computed: {
    color() {
      const statusOption = this.statusesOptions[this.item.status]
      return statusOption.color
    },
    icon() {
      const statusOption = this.statusesOptions[this.item.status]
      return statusOption.icon
    },
    index() {
      if (typeof this.idx === 'number') {
        return this.idx + 1
      }

      const indices = this.idx.split('.')
      return indices.map((el) => toNumber(el) + 1).join('.')
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormRow {
  &__title {
    font-size: 16px;
    font-weight: normal;
  }

  .bold {
    font-weight: bold;
  }
}
</style>
